import React from 'react';
import type { MultipleChoiceQuestion as MCQ } from '@/Data/Topik/types';
import './MultipleChoiceQuestion.scss';

interface MultipleChoiceQuestionProps {
    question: MCQ;
    selectedAnswer: string | undefined;
    onAnswerSelect: (questionId: number, answer: string) => void;
    showCorrectAnswer?: boolean;
}

export const MultipleChoiceQuestion: React.FC<MultipleChoiceQuestionProps> = ({ 
    question, 
    selectedAnswer, 
    onAnswerSelect,
    showCorrectAnswer = false
}) => {
    const optionLabels = ['A', 'B', 'C', 'D'];
    
    return (
        <div className="MultipleChoiceOptions SampleQuestionOptions">
            {question.choices.map((choice, index) => {
                const isSelected = selectedAnswer === optionLabels[index];
                const isCorrect = showCorrectAnswer && question.correct_answer === optionLabels[index];
                
                return (
                    <div 
                        key={index}
                        className={`Option ${isSelected ? 'selected' : ''} ${isCorrect ? 'correct' : ''}`}
                        onClick={() => onAnswerSelect(question.questionid, optionLabels[index])}
                    >
                    <span className="OptionCircle">{optionLabels[index]}</span>
                    <div className="OptionContent">
                        {choice.image_url && (
                            <div className="OptionImage">
                                {choice.image_url.endsWith('.html') ? (
                                    <iframe 
                                        src={choice.image_url} 
                                        width="230"
                                        height="230"
                                        frameBorder="0"
                                        title={`Option ${optionLabels[index]}`}
                                    />
                                ) : (
                                    <img src={choice.image_url} alt={`Option ${optionLabels[index]}`} />
                                )}
                            </div>
                        )}
                        <span className="OptionText">{choice.text}</span>
                    </div>
                </div>
                );
            })}
        </div>
    );
};